import { useTranslation } from "react-i18next";
import type { TrueFalseContent } from "../content-types";
import { Explanation, OptionRow, Prompt } from "./shared";
import { GlossableText, isLanguageFramework } from "./glossable-text";
import type { QuestionRendererProps } from "./types";

export function TrueFalseRenderer({
  content,
  answer,
  setAnswer,
  revealed,
  frameworkSlug,
}: QuestionRendererProps) {
  const { t } = useTranslation();
  const c = content as unknown as TrueFalseContent;
  const enableGloss = isLanguageFramework(frameworkSlug);

  const stateFor = (val: boolean): "neutral" | "selected" | "correct" | "wrong" => {
    if (!revealed) return answer === val ? "selected" : "neutral";
    if (val === c.correct) return "correct";
    if (answer === val) return "wrong";
    return "neutral";
  };

  return (
    <div>
      <Prompt>{enableGloss ? <GlossableText text={c.statement} context={c.statement} /> : c.statement}</Prompt>
      <div className="mt-4 grid grid-cols-2 gap-2">
        {[true, false].map((val) => (
          <OptionRow
            key={String(val)}
            state={stateFor(val)}
            disabled={revealed}
            onClick={() => !revealed && setAnswer(val)}
          >
            <span className="mx-auto font-semibold">{val ? t("True") : t("False")}</span>
          </OptionRow>
        ))}
      </div>
      {revealed && <Explanation text={c.explanation} />}
    </div>
  );
}
